import type { TFunction } from 'i18next'

const PATTERN_LABEL: Record<string, string> = {
	smooth: 'Smooth',
	erratic: 'Erratic',
	intermittent: 'Intermittent',
	lumpy: 'Lumpy',
}

export const patternLabel = (pattern: string, t: TFunction) =>
	pattern in PATTERN_LABEL
		? t(`midterm_forecast.pattern.${pattern}`, {
				defaultValue: PATTERN_LABEL[pattern],
			})
		: t('midterm_forecast.pattern.unknown', { defaultValue: 'Unknown' })

// Shared by the chart legend and the tooltip so key/default never drift.
export const LEGEND_LABELS = {
	actual: { key: 'midterm_forecast.legend_actuals', defaultValue: 'Actuals' },
	median: {
		key: 'midterm_forecast.legend_median',
		defaultValue: 'Forecast (median)',
	},
	band50: {
		key: 'midterm_forecast.legend_band50',
		defaultValue: '50% (q25–q75)',
	},
	band90: {
		key: 'midterm_forecast.legend_band90',
		defaultValue: '90% (q05–q95)',
	},
} as const
